import { addColorSet, createBasicColorSet, screenMdMin, spacer8, } from '@spotify-internal/encore-web';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { NavBarLanguageItem } from '../Language';
import { AuthButton, ClaimButton } from '../Actions';
import { flyoutTransitionMixin } from '../FlyoutMenu/config';
import { trackCat } from '../constants';
const StyledAuthButton = styled(AuthButton) `
  ${flyoutTransitionMixin('border-color', 'color')}
  border: 1px solid ${props => props.theme.text};
  color: ${props => props.theme.text};
  // overrides for focus / hover state of the encore button
  --essential-base: ${props => props.theme.text} !important;
  --parents-essential-base: ${props => props.theme.text} !important;
`;
const StyledClaimButton = styled.div `
  ${flyoutTransitionMixin('background-color', 'border-color', 'color')}
  // override for focus / hover state of the encore button
  --parents-essential-base: ${props => props.theme.text} !important;
`;
const ActionsWrapper = styled.section `
  & ul {
    align-items: center;
    display: flex;
    gap: ${spacer8};
    list-style: none;
    margin: 0;
    padding: 0;
  }

  @media (max-width: ${screenMdMin}) {
    display: none;
  }
`;
export const NavBarActionsWithLanguage = ({ language, userState, mastheadData, }) => {
    const languageSelectionEntry = mastheadData.fields
        .languageSelection;
    const theme = useTheme();
    return (React.createElement(ActionsWrapper, { className: "encore-layout-themes encore-creator-light-theme" },
        React.createElement("ul", { className: theme.forceInvertedDark ? addColorSet('invertedDark') : '' },
            React.createElement("li", null,
                React.createElement(NavBarLanguageItem, { container: "header", language: language, languageSelectionEntry: languageSelectionEntry })),
            React.createElement("li", null,
                React.createElement(StyledAuthButton, { size: "small", userState: userState, trackingCategory: trackCat })),
            React.createElement("li", null,
                React.createElement(StyledClaimButton, null,
                    React.createElement(ClaimButton, { size: "small", userState: userState, trackingCategory: trackCat, colorSet: theme.forceInvertedDark
                            ? undefined
                            : createBasicColorSet(theme === null || theme === void 0 ? void 0 : theme.text, theme === null || theme === void 0 ? void 0 : theme.background) }))))));
};
//# sourceMappingURL=ActionsWithLanguage.js.map